import { render, staticRenderFns } from "./customerDashboard.vue?vue&type=template&id=e29f4400&scoped=true"
import script from "./customerDashboard.vue?vue&type=script&lang=js"
export * from "./customerDashboard.vue?vue&type=script&lang=js"
import style0 from "./customerDashboard.vue?vue&type=style&index=0&id=e29f4400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29f4400",
  null
  
)

export default component.exports